<template>
  <validation-observer tag="form" @submit.native.prevent ref="validation">
    <fragment>
      <div class="card-body">
        <h2>Asset Lifecycle Report</h2>
        <p class="text-muted mb-0">Export a report containing screen details including installation dates, specifications, and warranty information.</p>
      </div>

      <ul class="filters">
        <li v-if="$isA('admin')">
          <div class="row">
            <label class="col-lg-3 col-form-label">Media owner</label>
            <div class="col-lg-9">
              <multiselect
                class="multiselect-multiple"
                multiple
                v-model="filters.mediaOwners"
                placeholder="Select"
                :preselect-first="false"
                :close-on-select="false"
                :show-labels="false"
                label="name"
                track-by="id"
                :options="mediaOwners"
              />
            </div>
          </div>
        </li>
        <li v-if="$isA('admin')">
          <div class="row">
            <label class="col-lg-3 col-form-label">Screen tags</label>
            <div class="col-lg-9">
              <multiselect
                class="multiselect-multiple"
                multiple
                v-model="filters.screenTags"
                placeholder="Select"
                :preselect-first="false"
                :close-on-select="false"
                :show-labels="false"
                label="name"
                track-by="id"
                :options="screenTags"
              />
            </div>
          </div>
        </li>
      </ul>

      <div class="card-body border-top text-end mt-auto">
        <c-button type="submit" variant="primary" @click="handleGenerateReport('csv')" validate class="ms-auto me-2">
          Download CSV
        </c-button>
        <c-button type="submit" variant="primary" @click="handleGenerateReport('pdf')" validate class="ms-auto mr-2">
          Download PDF
        </c-button>
      </div>
    </fragment>
  </validation-observer>
</template>

<script>
import { toast } from '@chameleon/chameleon-vue'
import { http } from '@/utils'
import { get, call } from 'vuex-pathify'

export default {
  data () {
    return {
      filters: {
        mediaOwners: [],
        screenTags: []
      }
    }
  },

  async created () {
    try {
      if (this.$isA('admin')) {
        await this.getMediaOwners()
      }
      await this.getScreenTags()
    } catch (e) {
      toast('We encountered an error. We have been alerted and will investigate.', 'danger')
      throw e
    }
  },

  computed: {
    mediaOwners: get('lists/mediaOwners/mediaOwners'),
    screenTags: get('lists/screenTags/screenTags')
  },

  methods: {
    getMediaOwners: call('lists/mediaOwners/getMediaOwners'),
    getScreenTags: call('lists/screenTags/getScreenTags'),

    handleGenerateReport (type) {
      const params = {
        screenTags: this.filters.screenTags.map(screenTag => screenTag.id),
        type: type
      }

      if (this.$isA('admin')) {
        params.mediaOwners = this.filters.mediaOwners.map(mediaOwner => mediaOwner.id)
      }

      return http
        .get('reports/screen-end-of-life', {
          responseType: 'blob',
          headers: { accept: 'application/json, text/csv' },
          params
        })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          const parts = ['AssetLifecycle']

          if (this.$isA('admin') && this.filters.mediaOwners && this.filters.mediaOwners.length > 0) {
            const mediaOwnerNames = this.filters.mediaOwners.map(mo => mo.name.replace(/\s+/g, '-').replace(/[^a-zA-Z0-9_-]/g, '')).join('_')
            parts.push(mediaOwnerNames)
          }

          parts.push('AllTime')

          const filename = `${parts.join('-')}.${type}`
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
          return response
        })
        .catch(e => {
          toast('We encountered an error. We have been alerted and will investigate.', 'danger')
          throw e
        })
    }
  }
}
</script>
